<template>
    <div v-if="((comprobacion.hijas && comprobacion.hijas.length) || comprobacion.esGrupo) && formato && !form.readonly">
      <f7-list-item
        accordion-item
        :key="'accordion-' + name"
        ref="accordion"
        @accordion:beforeopen="$set(comprobacion, 'accordionOpened', true)"
        @accordion:beforeclose="$set(comprobacion, 'accordionOpened', false)"
        class="margin-left tpm-accordion"
      >
        <div slot="media" class="display-flex align-self-center">
          <span
            v-if="!form.readonly"
            class="column-drag-handle margin-left cursor-move"
            v-tooltip="$t('common.move')"
          >&uarr;&darr;</span>
          <input
            :value="comprobacion.codigo"
            @change="comprobacion.codigo = $event.target.value"
            placeholder="Cód."
            style="width:3em; text-align:center;"
          />
        </div>
        <input
          slot="before-title"
          :value="comprobacion.nombre"
          @change="comprobacion.nombre = $event.target.value"
          placeholder="Nombre de la comprobación"
        />
        <span class="display-flex" slot="inner-end">
          Peso: <input
            v-if="formato"
            class="input-peso"
            type="number"
            :value="comprobacion.peso"
            @change="comprobacion.peso = $event.target.value"
            v-tooltip="$t('componentes.comprobacion.peso')"
          />
          <f7-button
            small
            class="display-flex align-self-center margin-right"
            icon-f7="trash"
            :icon-color="'red'"
            @click="$emit('delete', comprobacion)"
            v-tooltip="'Borrar'"
          ></f7-button>
        </span>
        
        <f7-accordion-content>
          <template v-if="comprobacion.accordionOpened">
            <Container
              group-name="comprobaciones"
              @drop="onDrop(comprobacion.hijas, $event)"
              :get-child-payload="getChildPayloadComprobaciones(comprobacion.hijas)"
              :should-accept-drop="(src, payload) => src.groupName == 'grupo-comprobaciones' || src.groupName == 'comprobaciones'"
              lock-axis="y"
              drag-handle-selector=".column-drag-handle"
            >
              <Draggable
                v-for="(hija, ih) in comprobacion.hijas"
                :key="name + '-' + ih"
              >
                <comprobacion
                  :comprobacion="hija"
                  :name="name + '.hijas.' + ih"
                  :form="form"
                  :resultadoDefecto="hija.valorInicial"
                  :formato="formato"
                  @delete="deleteComprobacion(comprobacion.hijas, ih, $event)"
                  :getChildPayloadComprobaciones="getChildPayloadComprobaciones"
                  :tabletFormat="tabletFormat"
                  :pathPadre="pathPadre"
                  @changeChild="$emit('changeChild', $event)"
                  :offline="offline"
                ></comprobacion>
              </Draggable>
            </Container>
          </template>
          <template v-else>
            <div :style="'min-height: 38px; height:' + (comprobacion.hijas ? comprobacion.hijas.length * 38 : 0) + 'px;'">{{' '}}</div>
          </template>
        </f7-accordion-content>
      </f7-list-item>
    </div>
    <div v-else-if="(comprobacion.hijas && comprobacion.hijas.length) || comprobacion.esGrupo">
      <f7-list-item 
        accordion-item
        :key="'accordion-' + name"
        @accordion:beforeopen="$set(comprobacion, 'accordionOpened', true)"
        @accordion:beforeclose="$set(comprobacion, 'accordionOpened', false)"
        class="margin-left tpm-accordion"
      >
        <div slot="media" class="display-flex align-self-center">
          <div class="display-flex align-self-center">
            {{ comprobacion.codigo }}
          </div>
        </div>
        <div slot="before-title">{{ comprobacion.nombre }}</div>
        <div class="display-flex">
          <div v-if="formato" class="margin-right display-flex">
              <!-- Peso: {{ comprobacion.peso }} -->
            Peso: <input
              v-if="formato"
              class="input-peso"
              type="number"
              :value="comprobacion.peso"
              @change="comprobacion.peso = $event.target.value"
              v-tooltip="$t('componentes.comprobacion.peso')"
              readonly="readonly"
            />
          </div>
          <f7-button
            outline
            small
            class="display-flex align-self-center margin-right"
            :fill="allHijasNACurrent"
            @click.stop="onClickNA(comprobacion)"
            :disabled="form.readonly"
            :style="allHijasPrecargaNACurrent?'border: 2px solid;':''"
            >NA</f7-button
          >
          <f7-checkbox
            class="display-flex align-self-center margin-right"
            :checked="comprobacion.hecho"
            @change="
              comprobacion.hecho = $event.target.checked
            "
          ></f7-checkbox>
        </div>
  
        <div style="flex-basis: 100%; height: 0;"></div>
        <f7-accordion-content>
          <template v-if="comprobacion.accordionOpened">
            <comprobacion
              v-for="(hija, ih) in comprobacion.hijas"
              :key="name + '-' + ih"
              :comprobacion="hija"
              :name="name + '.hijas.' + ih"
              :form="form"
              :formato="formato"
              :resultadoDefecto="hija.valorInicial"
              :tabletFormat="tabletFormat"
              :pathPadre="pathPadre"
              @changeChild="$emit('changeChild', $event)"
              :offline="offline"
            ></comprobacion>
          </template>
          <template v-else>
            <div :style="'height:' + (comprobacion.hijas ? comprobacion.hijas.length * 38 : 0) + 'px;'">{{' '}}</div>
          </template>
        </f7-accordion-content>
      </f7-list-item>
    </div>
    <div v-else :style="historicoNoCoincide?'background-color: #f8d7da; border-color: #f5c6cb; color: #721c24;':''">
      <li
        :class="{
          'defecto-agregado':
            comprobacion.defectosSeleccionados &&
            comprobacion.defectosSeleccionados.length,
          'con-defecto-anterior':comprobacion.conDefectoAnterior,
        }"
      >
        <div v-tooltip="erroresAuditoriaTooltip" v-if="comprobacion.erroresAuditoria && comprobacion.erroresAuditoria.length" v-html="formateoError(comprobacion)" @click.prevent="mostrarError(comprobacion)" style="z-index: 100;"></div>
        <div class="item-content">
          <div class="item-inner">
            <div
              class="item-cabecera"
            >
              <span 
                v-if="formato && !form.readonly"
                class="column-drag-handle margin-left cursor-move"
                v-tooltip="$t('common.move')"
              >&uarr;&darr;</span>
              <a style="width:3em; text-align:center;" @click="openInstruccionesPopup">
                <i class="f7-icons text-color-primary comprobacion-icono">info_circle_fill</i>
              </a>
              <input
                :class="'item-codigo ' + (comprobacion.conDefectoAnterior?'con-defecto-anterior':'')"
                :value="comprobacion.codigo"
                @change="comprobacion.codigo = $event.target.value; "
                placeholder="Cód."
                style="width:4em; text-align:center;"
                :readonly="!formato || form.readonly"
              />
              <input
                class="item-titulo"
                :value="comprobacion.nombre"
                @change="comprobacion.nombre = $event.target.value"
                placeholder="Nombre."
                :readonly="!formato || form.readonly"
                v-tooltip="comprobacion.nombre"
              />
              <div v-if="formato" class="margin-right display-flex">
                {{$t('componentes.comprobacion.peso')}}: 
                <input
                  class="input-peso"
                  type="number"
                  :value="comprobacion.peso"
                  @change="comprobacion.peso = $event.target.value"
                  v-tooltip="$t('componentes.comprobacion.peso')"
                  :readonly="form.readonly"
                />
              </div>
              <!-- <div class="item-codigo">{{ comprobacion.codigo }}</div> -->
              <!-- <div class="item-titulo">{{ comprobacion.nombre }}</div> -->
            </div>
            <div class="item-after">
              <div class="display-flex width-100">
                <div class="comprobacion-radios align-items-center display-flex">
                  <label
                    v-for="rv in [
                      { valor: 'F', color: 'green' },
                      { valor: 'D', color: 'orange' },
                      { valor: 'NA', color: 'gray' },
                    ]"
                    :key="'rvc-' + comprobacion.codigo + '-' + rv.valor"
                    class="radio label-radio"
                    :class="{disabled: isDisabled(form.readonly) }"
                    :class_="{ disabled: (form.readonly || !formato && form.editarEnIntranet !== undefined && !form.editarEnIntranet) }"
                  >
                    <f7-button
                      :fill="rv.valor == 'D' ? isDefectResult : (rv.valor == currentResultado)"
                      raised
                      :color="
                        rv.valor == 'D' &&
                        comprobacion.defectosSeleccionados &&
                        comprobacion.defectosSeleccionados.length
                          ? 'red'
                          : rv.color
                      "
                      :class="{disabled: isDisabled(comprobacion.bloqueado) }"
                      :class_="{disabled: (comprobacion.bloqueado || !formato && form.editarEnIntranet !== undefined && !form.editarEnIntranet) }"
                      :style="{ border: ((!currentResultado) && comprobacion.precarga === rv.valor) ? `2px solid ${rv.color}` : 'none' }"
                      @click.stop.prevent="onResultClick(rv.valor)"
                      >{{ rv.valor }}</f7-button
                    >
                  </label>
                  <f7-link
                    v-if="hasHistory && Utils.posterior2Dic2024(form.dateRef)"
                    class="r-input-little r-input-top history-link"
                    :class="{'color-historico-ultimo-online': historicoTieneCambiosOnline}"
                    :icon-f7="'archivebox'"
                    v-tooltip="'Historico de valores'"
                    @click="showHistory($event, name + '.resultado')"
                  ></f7-link>
                  <div v-else class="r-input-little r-input-top" style="width: 10.6562px;"></div>
                </div>
                <div class="input-dropdown-wrap width-100 margin-right" v-if="!tabletFormat || currentResultado == 'D'">
                  <select
                    :class="{ disabled: form.readonly || !formato && comprobacion.resultado != 'D' && comprobacion.resultado != 'DL' && comprobacion.resultado != 'DG' && comprobacion.resultado != 'DMG' }"
                    class="comprobacion-select"
                    @change="
                      $event.target.value
                        ? (defecto = JSON.parse(
                            JSON.stringify(
                              comprobacion.defectos[$event.target.value]
                            )
                          ))
                        : (defecto = null)
                    "
                  >
                    <option value></option>
                    <option
                      v-for="(opt, io) in comprobacion.defectos"
                      :key="comprobacion.codigo + '-' + io"
                      :value="io"
                      :selected="defecto && JSON.stringify(defecto) == JSON.stringify(opt)"
                      >{{ opt.categoria }} - {{ opt.nombre }}</option
                    >
                  </select>
                </div>
              </div>
              <div class="comprobacion-botones align-items-center display-flex" >
                <!-- v-if="!formato" -->
                <!-- :class="{ disabled: !defecto }" -->
                <f7-button
                  v-if="isDefectResult"
                  @click="
                    tituloPopup = 'Comentario';
                    comentarios = '';
                    popupOpenedComentarios = true;
                    $nextTick(function() {
                      $refs.popupComentario.open();
                    });
                  "
                  class="label-radio"
                  :class="{ disabled: form.readonly || !defecto }"
                  icon-material="comment"
                  :icon-color="'primary'"
                  v-tooltip="'Añadir observaciones'"
                ></f7-button>
                <f7-button
                  v-else
                  @click="
                    tituloPopup = 'Observaciones de la comprobación ' + comprobacion.codigo;
                    comentarios = comprobacion.observaciones;
                    popupOpenedComentarios = true;
                    $nextTick(function() {
                      $refs.popupComentario.open();
                    });
                  "
                  class="label-radio"
                  :class="{ disabled: form.readonly }"
                  icon-material="comment"
                  :icon-color="'primary'"
                  v-tooltip="'Añadir observaciones'"
                ></f7-button>
                <!-- v-if="!formato" -->
                <!-- :class="{ disabled: !defecto }" -->
                <f7-button
                  v-if="isDefectResult"
                  class="label-radio"
                  :icon-material="tabletFormat?'perm_camera_mic':'attach_file_add'"
                  v-tooltip="tabletFormat?'Multimedia':'Documentación'"
                  :icon-color="'primary'"
                  @click="$refs.popoverMultimedia.open($event.target)"
                  :class="{ disabled: form.readonly || !defecto}"
                  ref="targetPopoverMultimedia"
                ></f7-button>
                <f7-button
                  v-else
                  class="label-radio"
                  :icon-material="tabletFormat?'perm_camera_mic':'attach_file_add'"
                  v-tooltip="tabletFormat?'Multimedia':'Documentación'"
                  :icon-color="'primary'"
                  @click="$refs.popoverMultimedia.open($event.target)"
                  :class="{ disabled: form.readonly}"
                  ref="targetPopoverMultimedia"
                ></f7-button>
                <f7-popover ref="popoverMultimedia" class="popover-menu">
                  <f7-list>
                    <f7-list-item
                      v-if="tabletFormat"
                      popover-close
                      title="Foto"
                      @click="Utils.capturarFoto(form, comprobacionDefectuosa() ? 'tmpdocumentos' : name + '.documentos', Utils.getInspeccionPath(pathPadre + (comprobacionDefectuosa() ? `/Defectos/${defecto.codigo}` : `/Comprobaciones/${comprobacion.codigo}`), form.formData), $set)"
                      link="#"
                    >
                      <f7-icon
                        slot="media"
                        material="add_a_photo"
                        color="primary"
                      ></f7-icon>
                    </f7-list-item>
                    <f7-list-item
                      v-if="tabletFormat"
                      popover-close
                      title="Vídeo"
                      @click="Utils.grabarVideo(form, comprobacionDefectuosa() ? 'tmpdocumentos' : name + '.documentos', Utils.getInspeccionPath(pathPadre + (comprobacionDefectuosa() ? `/Defectos/${defecto.codigo}` : `/Comprobaciones/${comprobacion.codigo}`), form.formData), $set)"
                      link="#"
                    >
                      <f7-icon
                        slot="media"
                        material="video_call"
                        color="primary"
                      ></f7-icon>
                    </f7-list-item>
                    <f7-list-item
                      v-if="tabletFormat"
                      popover-close
                      title="Audio"
                      @click="Utils.grabarAudio(form, comprobacionDefectuosa() ? 'tmpdocumentos' : name + '.documentos', Utils.getInspeccionPath(pathPadre + (comprobacionDefectuosa() ? `/Defectos/${defecto.codigo}` : `/Comprobaciones/${comprobacion.codigo}`), form.formData), $set)"
                      link="#"
                    >
                      <f7-icon
                        slot="media"
                        material="mic"
                        color="primary"
                      ></f7-icon>
                    </f7-list-item>
                    <f7-list-item
                      popover-close
                      title="Documento "
                      @click="anadirDocumento"
                      link="#"
                    >
                      <f7-icon
                        slot="media"
                        material="attach_file"
                        color="primary"
                      ></f7-icon>
                    </f7-list-item>
                  </f7-list>
                </f7-popover>
                <f7-button
                  v-if="!formato && (!tabletFormat || isDefectResult)"
                  @click="anadirDefecto()"
                  class="label-radio"
                  icon-f7="plus"
                  :icon-color="'primary'"
                  :class="{ disabled: !defecto }"
                  v-tooltip="'Añadir defecto'"
                ></f7-button>
                <f7-button
                  v-if="formato && !form.readonly"
                  class="label-radio"
                  icon-f7="trash"
                  :icon-color="'red'"
                  @click="$emit('delete', comprobacion)"
                  v-tooltip="'Borrar'"
                ></f7-button>
              </div>
            </div>
          </div>
        </div>
  
        <f7-popup
          v-if="popupOpenedInstrucciones"
          @popup:closed="popupOpenedInstrucciones = false"
          ref="popupInstrucciones"
        >
          <f7-page>
            <f7-navbar title="Instrucciones">
              <f7-nav-right>
                <f7-link
                  @click="$refs.popupInstrucciones.close()"
                  icon-f7="multiply"
                ></f7-link>
              </f7-nav-right>
            </f7-navbar>
            <f7-block>
              <r-rich-text-input
                v-if="formato"
                :disabled="form.readonly"
                class="col-100"
                floating-label
                :label="comprobacion.nombre"
                :placeholder="$t('componentes.comprobacion.instrucciones')"
                name="instrucciones"
                :form="{ formData: comprobacion }"
                :showVideoButton="true"
              ></r-rich-text-input>
              <r-rich-text-input
                v-else
                :disabled="true"
                class="col-100"
                floating-label
                :label="comprobacion.nombre"
                :placeholder="$t('componentes.comprobacion.instrucciones')"
                name="instruccionesTexto"
                :form="{ formData: { instruccionesTexto: instruccionesTexto } }"
                :showVideoButton="true"
              ></r-rich-text-input>
            </f7-block>
          </f7-page>
        </f7-popup>
        <f7-popup
          v-if="popupOpenedComentarios"
          @popup:closed="popupOpenedComentarios = false"
          ref="popupComentario"
        >
          <f7-page>
            <f7-navbar :title="tituloPopup">
              <f7-nav-right>
                <f7-link
                  @click="$refs.popupComentario.close()"
                  icon-f7="checkmark"
                ></f7-link>
              </f7-nav-right>
            </f7-navbar>
            <div class="list no-hairlines no-margin full-height">
              <ul class="full-height">
                <li class="item-content item-input full-height">
                  <div class="item-inner full-height">
                    <div class="item-input-wrap full-height">
                      <textarea
                        placeholder="Escribe aquí algún comentario..."
                        class="full-height textoAzul"
                        :value="comentarios"
                        @change="setComment($event.target.value)"
                      ></textarea>
                      <f7-button
                        outline
                        class="display-flex align-self-center margin-right"
                        fill
                        @click="$refs.popupComentario.close()"
                      >Guardar</f7-button>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </f7-page>
        </f7-popup>
      </li>
      <f7-popover class="history-popover" :closeByBackdropClick="false" :backdrop="true" closeOnEscape ref="popoverHistory" style="width: auto; max-width: 90%;">
        <div style="min-width: 250px;">
          <f7-navbar :title="$t('Historico de cambios')">
            <f7-nav-right>
              <f7-link popover-close icon-f7="multiply"></f7-link>
            </f7-nav-right>
          </f7-navbar>
          <f7-block>
          <div class="scrollable-content">
            <table>
              <thead>
                <tr style="background-color: #22355b;color: #FFF;">
                  <th>Valor</th>
                  <th>Fecha</th>
                  <th>Usuario</th>
                </tr>
              </thead>
              <tbody  v-if="form.username != 'NOID'">
                <tr v-for="(itm, idx) in history" :key="'history-' + idx" :class="(idx%2?'fila-impar':'fila-par')">
                  <td class="datos-valor" :title="itm && itm.msgHistory?itm.msgHistory:''">{{itm.valor}}</td>
                  <td class="datos-auditoria">{{itm.date}}</td>
                  <td class="datos-auditoria">{{itm.username || ' - '}}</td>
                </tr>
              </tbody>
              <tbody  v-else>
                <tr v-for="(itm, idx) in history" :key="'history-' + idx" :class="(idx%2?'fila-impar':'fila-par')">
                  <td class="datos-valor" :title="itm && itm.msgHistory?itm.msgHistory:''">
                    <div>
                      <select
                        :value="getValueHistory(itm.valor)"
                        @change="setValueHistory($event.target.value, $event.target, true, false, itm)"
                      >
                        <option v-for="(opt, io) in ['F','D','NA']" :key="'history-' + idx + '-' + io + '-' + opt" :value="opt" :selected="itm.valor == opt" style="text-align: center;width: 30px;">{{opt}}</option>
                      </select>
                    </div>
                  </td>
                  <td class="datos-auditoria">
                    <!-- {{itm.date}} -->
                    <f7-list-input
                      :value="getDateHistory(itm.date)"
                      :type="'datetime-local'"
                      @input="itm.date = $event.target.value"
                      @change="itm.date = $event.target.value"
                      @calendar:change="itm.date = $event.target.value"
                      v-on="$listeners"
                    ></f7-list-input>
                  </td>
                  <td class="datos-auditoria">
                    <f7-list-input
                      :value="itm.username"
                      type="text"
                      @change="itm.username = $event.target.value"
                    />
                  </td>
                  <td class="datos-opciones">
                    <f7-link @click="updateHistory(itm)" icon-f7="floppy_disk"></f7-link>
                    <f7-link @click="deleteFieldFromHistory(itm)" icon-f7="trash" color="red"></f7-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </f7-block>
        </div>
      </f7-popover>
    </div>


</template>
<style scoped>
/* COMPROBACIONES */

.tpm-accordion.accordion-item {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.tpm-accordion.accordion-item .accordion-item-content {
  width: 100%;
}

.item-codigo, .item-titulo {
  border: none;
  background: transparent;
  width: 100%;
}

.comprobacion-select {
  margin: 0 10px;
  width: 200px;
}

.comprobacion-botones > *,
.comprobacion-radios .button {
  min-width: 2.2rem;
  width: 2.2rem;
  margin: 0 2px;
  padding: 0;
}

.radio input[type="radio"]:not(:checked) ~ .button {
  background: white;
  color: gray;
}

.defecto-agregado .radio input[type="radio"] ~ .button.color-orange {
  background: #f44336;
}

.defecto-agregado label.radio {
  pointer-events: none !important;
}

.accordion-item .accordion-item-content .item-cabecera {
  display: flex;
  width: 100%;
}
.accordion-item .accordion-item-content .item-codigo {
  font-weight: bold;
  flex: 0 0 3em;
}
.comprobacion-botones {
  width: auto;
}

.accordion-item {
  background-color: #f3f3f3;
}
.accordion-item-content {
  background-color: white;
}
.block-title > input {
  background: transparent;
  border: none;
  font-weight: bold;
  width: 100%;
}
.accordion-item > .item-link input {
  border: none;
  background: transparent;
  width: auto;
  width: 100%;
}
.accordion-item > .nombre-precarga,
.accordion-item > .nombre-plantilla {
  border: none;
  background: transparent;
  width: auto;
  width: 95%;
}
.accordion-item .file-container{
  display:inline-block;
  width: 150px;
}
.accordion-item > .item-link input.input-peso, div.margin-right input.input-peso {
  width: 35px;
  border: 1px solid black;
  background-color: white;
  margin-left: 5px;
  padding-left: 2px;
}
.last-row-item-in-accordion {
  margin-bottom: 10em;
}

.textoAzul {
  color: blue;
  text-transform: uppercase;
}
.con-defecto-anterior {
  color: red;
}
li.con-defecto-anterior {
  border: 1px dashed red;
  background-color: #ffefef;
}

.custom-select {
  position: relative;
  display: inline-block;
  width: 100%;
}

.custom-select select {
  appearance: none; /* Elimina el estilo predeterminado del navegador */
  -webkit-appearance: none; /* Para navegadores basados en WebKit */
  -moz-appearance: none; /* Para Firefox */
  background: transparent;
  width: 100%;
  padding-right: 30px; /* Espacio para el icono */
}

.custom-select::after {
  content: '▼'; /* Icono de flecha */
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  pointer-events: none; /* Evita que el icono interfiera con los clics */
  font-size: 12px;
  color: #000;
}

@media (max-width: 767px) {
  .accordion-item .accordion-item-content .item-cabecera {
    width: 100%;
  }
  .accordion-item .accordion-item-content .item-titulo {
    width: 100%;
  }

  .accordion-item .accordion-item-content .item-content {
    padding: 0;
  }
  .accordion-item .accordion-item-content .item-inner {
    flex-direction: column;
    align-items: start;
    padding: 5px;
  }
  .accordion-item .accordion-item-content .item-after {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .comprobacion-select {
    width: 100%;
  }
}
@media (max-width: 550px) {
  .accordion-item .accordion-item-content .item-after {
    flex-direction: column;
    align-items: start;
  }
  .comprobacion-botones {
    margin: 0px 5px 0px auto;
  }
}
</style>
<style>
  .tpm-accordion.accordion-item .item-link{
    flex: 50%;
  }
</style>
<script>
import moment from 'moment';
import rForm from "./../../components/rForm.vue";
import rInput from "./../../components/rInput.vue";
import rFiles from "./../../components/rFiles.vue";
import DocumentoOffline from "./../../js/db/DocumentoOffline.js";
import rRichTextInput from "./../../components/rRichTextInput.vue";
import { Container, Draggable } from "vue-smooth-dnd";
import Utils from "./../../js/Utils";
import Formato from "./../../js/db/Formato.js";
import FormatoOffline from "./../../js/db/FormatoOffline.js";
import { EventBus } from "../../js/EventBus";
import DateUtils from "../../js/DateUtils";
import JSONPath from 'jsonpath';

const applyDrag = (arr, dragResult) => {
  const { removedIndex, addedIndex, payload } = dragResult;
  if (removedIndex === null && addedIndex === null) return arr;
  console.log(arr, dragResult);
  //const result = [...arr];
  if (!arr) arr = [];
  var result = arr;

  let itemToAdd = payload;

  if (removedIndex !== null) {
    itemToAdd = Object.assign({},  result.splice(removedIndex, 1)[0]);
  }

  if (addedIndex !== null) {
    result.splice(addedIndex, 0, Object.assign({}, itemToAdd));
  }

  //return result;
};

export default {
  name: "comprobacion",
  components: { rForm, rInput, rFiles, rRichTextInput, Container, Draggable },
  data() {
    return {
      self: this,
      popupOpenedComentarios: false,
      popupOpenedInstrucciones: false,
      // Para el nuevo defecto
      comentarios: "",
      defecto: null,
      // documentos: [],
      DocumentoOffline,
      tituloPopup: "Comentario",
      comentarios: "",
      Utils,
      Formato,
      FormatoOffline,
      history: {},
      instruccionesTexto: ''
    };
  },
  props: {
    form: {},
    comprobacion: { type: Object },
    name: { type: String },
    referencia: { type: String },
    estandar: { type: String },
    subEstandar: { type: String },
    resultadosValidos: { type: Array },
    resultadoDefecto: { type: String },
    formato: { type: Boolean, default: false },
    getChildPayloadComprobaciones: Function,
    tabletFormat: { type: Boolean, default: false },
    pathPadre: { type: String, default: "Documentos" },
    offline: { type: Boolean },
  },
  computed: {
    isOfflineMode: function() {
      return !!this.offline;
    },
    hasHistory: function () {
      const self = this;
      if (self.isOfflineMode) {
        return false;
      }
      return self.form && self.form.history && self.form.history[(self.name + '.resultado')];
    },
    currentValue: function() {
      return this.getValue();
    },
    currentResultado: function() {
      const fromPath = this.currentValue && typeof this.currentValue === "object"
        ? this.currentValue.resultado
        : undefined;
      if (fromPath !== undefined && fromPath !== null) {
        return fromPath;
      }
      return this.comprobacion ? this.comprobacion.resultado : null;
    },
    isDefectResult: function() {
      return this.currentResultado == "D" || this.currentResultado == "DL" || this.currentResultado == "DG" || this.currentResultado == "DMG";
    },
    allHijasNACurrent: function() {
      return this.allHijasNA(this.comprobacion);
    },
    allHijasPrecargaNACurrent: function() {
      return this.allHijasPrecargaNA(this.comprobacion);
    },
    erroresAuditoriaTooltip: function() {
      const errores = this.comprobacion && this.comprobacion.erroresAuditoria ? this.comprobacion.erroresAuditoria : [];
      return errores.map(e => '<b>' + e.nombre + '.- </b>' + e.error).join('<br/>');
    },
    rolesConAuditoria: function() {
      if (this.isOfflineMode) {
        return false;
      }
      const roles = this.form && this.form.user ? this.form.user.roles : null;
      if (!roles || !roles.length) {
        return false;
      }
      for (let i = 0; i < roles.length; i++) {
        if (roles[i] == 'ADMINISTRACION' || roles[i] == 'ADMIN' || roles[i] == 'DTYCAL') {
          return true;
        }
      }
      return false;
    },
    latestResultadoHistory: function() {
      if (this.isOfflineMode) {
        return null;
      }
      const history = this.form && this.form.history ? this.form.history[this.name + ".resultado"] : null;
      if (!history || !history.length) {
        return null;
      }
      let latest = history[0];
      let latestTs = new Date(latest.date).getTime() || 0;
      for (let i = 1; i < history.length; i++) {
        const ts = new Date(history[i].date).getTime() || 0;
        if (ts > latestTs) {
          latest = history[i];
          latestTs = ts;
        }
      }
      return latest;
    },
    historicoTieneCambiosOnline: function() {
      if (this.isOfflineMode) return false;
      if (!this.rolesConAuditoria || !this.latestResultadoHistory) return false;
      var sesionesManuales = this.form && this.form.formData ? this.form.formData.sesionesManuales : null;
      return !Utils.fechaEnSesionesManuales(this.latestResultadoHistory.date, sesionesManuales);
    },
    historicoNoCoincide: function() {
      if (this.isOfflineMode) {
        return false;
      }
      if (!this.rolesConAuditoria || !this.latestResultadoHistory) {
        return false;
      }
      return this.getStrValueHistory(this.latestResultadoHistory.valor) != this.getStrValueHistory(this.currentResultado || '');
    },
  },
  methods: {
    onClickNA(comprobacion) {
      const self = this;
      if (comprobacion && comprobacion.hijas && comprobacion.hijas.length) {
        comprobacion.hijas.forEach((hija, idx) => {
          if (hija.resultado != 'D' && hija.resultado != 'DL' && hija.resultado != 'DG' && hija.resultado != 'DMG') {
            self.$set(comprobacion.hijas[idx], "resultado", "NA");
            self.$set(comprobacion.hijas[idx], "modificadaInspector", true);
          }
          self.onClickNA(hija);
        });
      } else {
        self.$emit("changeChild", comprobacion);
      }
    },
    allHijasNA(comprobacion) {
      const self = this;
      var resultado = true;
      if (comprobacion && comprobacion.hijas && comprobacion.hijas.length) {
        for (const hija of comprobacion.hijas) {
          var res = hija.resultado;
          if (typeof res == "undefined") {
            res = hija.valorInicial;
          }
          if (res != "NA") {
            resultado = false;
            return resultado;
          } else {
            resultado = self.allHijasNA(hija);
            if (!resultado) {
              return resultado;
            }
          }
        }
      }
      return resultado;
    },
    allHijasPrecargaNA(comprobacion) {
      const self = this;
      var resultado = true;
      if (comprobacion && comprobacion.hijas && comprobacion.hijas.length) {
        for (const hija of comprobacion.hijas) {
          var res = hija.precarga;
          if (res != "NA") {
            resultado = false;
            return resultado;
          } else {
            resultado = self.allHijasPrecargaNA(hija);
            if (!resultado) {
              return resultado;
            }
          }
        }
      }
      return resultado;
    },
    onDrop(arr, dropResult) {
      applyDrag(arr, dropResult);
    },
    deleteComprobacion(comprobaciones, ic, comprobacion) {
      var self = this;
      applyDrag(comprobaciones, {removedIndex: ic, payload: null, addedIndex: null});
    },
    anadirDocumento() {
      var self = this;
      var app = self.$f7;
      var x = document.createElement("INPUT");
      x.setAttribute("type", "file");
      x.onchange = function(e) {
        Array.from(e.target.files).forEach((file) => {
          if (self.tabletFormat) {
            // const numFileName = (!value || !value.length ? 0 : Math.max(...value.map(d => d.nombre.indexOf("[") < 0 ? 0 : parseInt(d.nombre.split(']')[0].split('[').slice(-1).join() || "0", 10) || 0))) + 1;
            const timestamp = moment().format("YYYYMMDDHHmmss");
            const offlinePath = Utils.getInspeccionPath(self.pathPadre + (self.comprobacionDefectuosa() ? `/Defectos/${self.defecto.codigo}` : `/Comprobaciones/${self.comprobacion.codigo}`), self.form.formData);
            DocumentoOffline.saveBlob(file, 'Documents/', `${offlinePath}/${timestamp}_${file.name}`)
              .then(({ filePath, localURL }) => {
                var fileLoaded = {
                  nombre: file.name.split(".").slice(0, -1).join("."),
                  extension: /(?:\.([^.]+))?$/.exec(file.name)[1], //file.type.split("/")[1],
                  _localURL: localURL,
                  offlinePath: filePath
                };
                if (self.comprobacionDefectuosa()) {
                  if (!self.form.formData.tmpdocumentos) { self.form.formData.tmpdocumentos = []; }
                  self.form.formData.tmpdocumentos.push(fileLoaded);
                } else {
                  if (!self.comprobacion.documentos) { self.comprobacion.documentos = []; }
                  self.comprobacion.documentos.push(fileLoaded);
                }
                app.preloader.hide();

              }).catch(e => {
                app.dialog.alert("Error guardando documento " + e);
                app.preloader.hide();
              })
          } else {
            var reader = new FileReader();
            reader.onload = function (e2) {
              if (self.comprobacionDefectuosa()) {
                if (!self.form.formData.tmpdocumentos) { self.form.formData.tmpdocumentos = []; }
                self.form.formData.tmpdocumentos.push({
                  nombre: file.name
                    .split(".")
                    .slice(0, -1)
                    .join("."),
                  extension: /(?:\.([^.]+))?$/.exec(file.name)[1],
                  _base64: e2.target.result,
                });
              } else {
                if (!self.comprobacion.documentos) { self.comprobacion.documentos = []; }
                self.comprobacion.documentos.push({
                  nombre: file.name
                    .split(".")
                    .slice(0, -1)
                    .join("."),
                  extension: /(?:\.([^.]+))?$/.exec(file.name)[1],
                  _base64: e2.target.result,
                });
              }
              app.preloader.hide();
            };
            reader.readAsDataURL(file);
          }
          app.preloader.show();
        });
      };
      x.click();
    },
    anadirDefecto() {
      var self = this;
      // self.defecto.observaciones = self.comentarios;
      // self.defecto.documentos = self.documentos;
      // var defSeleccionados = self.comprobacion.defectosSeleccionados || [];
      // defSeleccionados.push(self.defecto);
      // self.$set(self.comprobacion, "defectosSeleccionados", defSeleccionados);
      self.comprobacion.defectosSeleccionados.push(Object.assign({}, self.defecto, { observaciones: self.comentarios, documentos: self.form.formData.tmpdocumentos || []}));
      self.defecto = null;
      self.comentarios = "";
      self.form.formData.tmpdocumentos = [];
    },
    comprobacionDefectuosa() {
      return this.isDefectResult;
    },
    getValue: function() {
      var self = this;
      var namespaces = self.name.split(".");
      var context = self.form.formData;
      for (var i = 0; i < namespaces.length; i++) {
        if (typeof context == "undefined") {
          let n = namespaces[i];
          if (0 === n % (!isNaN(parseFloat(n)) && 0 <= ~~n)) {
            //Número entero positivo
            context = [];
          } else {
            context = {};
          }
        }
        context = context[namespaces[i]];
      }
      //context = context["resultado"];
      return context;
    },
    showHistory: function(event, name) {
      const self = this;
      // Clonamos shallow cada item para que el formateo posterior no mute el histórico original.
      let entradas = self.form.history[name || self.name] || [];
      // En modo NOID el histórico se edita y se borra entrada a entrada, así que allí lo mostramos
      // completo; para el resto colapsamos las ráfagas de valores repetidos consecutivos.
      if (self.form.username != 'NOID') {
        entradas = Utils.colapsaRafagasHistorico(entradas, valor => self.getStrValueHistory(valor));
      }
      self.history = entradas.map(itm => ({...itm}));
      // vamos a formatear los campos de fecha
      for (var i = 0; i < self.history.length; i++) {
        if (self.history[i].valor === undefined) {
          self.history[i].valor = '';
        }
        if (self.history[i].valorAnterior === undefined) {
          self.history[i].valorAnterior = '';
        }

        switch (self.type) {
          case 'check':
            if (self.history[i].valor === true) {
              self.history[i].valor = 'Si';
            } else if (self.history[i].valor === false) {
              self.history[i].valor = 'No';
            }
            if (self.history[i].valorAnterior === true) {
              self.history[i].valorAnterior = 'Si';
            } else if (self.history[i].valorAnterior === false) {
              self.history[i].valorAnterior = 'No';
            }
            break;
          case 'date':
          case 'datetime-local':
          case 'datepicker':
            self.history[i].valor = DateUtils.isDate(self.history[i].valor) ? self.history[i].valor : DateUtils.dateFormat(self.history[i].valor, self.formatDate);
            self.history[i].valorAnterior = DateUtils.isDate(self.history[i].valorAnterior) ? self.history[i].valorAnterior : DateUtils.dateFormat(self.history[i].valorAnterior, self.formatDate);
            break;
        }

        self.history[i].date = DateUtils.dateFormat(self.history[i].date, 'DD/MM/YYYY HH:mm');
        self.history[i].username = self.history[i].username || '-';
      }
      if(event.target) self.$refs.popoverHistory.open(event.target);
    },
    // si en el historico tenemos algún registro que en el campo nuevo tengan valor para el campo v_doc informado, devolvemos verde
    hayCambiosOnline: function () {
      const self = this;
      // miramos si el usuario tiene rol ADMINISTRACION, ADMIN o DTYCAL 
      let colorear = false;
      let roles = self.form.user ? self.form.user.roles : null;
      if (roles && roles.length) {
        for (var i = 0; i < roles.length; i++) {
          if (roles[i] == 'ADMINISTRACION' || roles[i] == 'ADMIN' || roles[i] == 'DTYCAL') {
            colorear = true;
            break;
          }
        }
      }
      let history = self.form.history ? self.form.history[self.name + ".resultado"] : null;
      // ahora ordenamos el historico por fecha y nos quedamos con el elemento mas reciente
      history = history?[...history] : [];
      history = history.sort((a, b) => new Date(b.date) - new Date(a.date));
      // si el elemento mas reciente tiene el campo punto, devolveremos true
      return colorear && history && history.length && !history[0].esOffline;
    },
    noCoincideHistorico: function () {
      const self = this;
      // miramos si el usuario tiene rol ADMINISTRACION, ADMIN o DTYCAL 
      let nocoincide = false;
      let roles = self.form.user ? self.form.user.roles : null;
      if (roles && roles.length) {
        for (var i = 0; i < roles.length; i++) {
          if (roles[i] == 'ADMINISTRACION' || roles[i] == 'ADMIN' || roles[i] == 'DTYCAL') {
            nocoincide = true;
            break;
          }
        }
      }
      let history = self.form.history ? self.form.history[self.name + ".resultado"] : null;
      // ahora ordenamos el historico por fecha y nos quedamos con el elemento mas reciente
      history = history?[...history] : [];
      history = history.sort((a, b) => new Date(b.date) - new Date(a.date));
      // miraremos si el valor del historico más reciente, coincide con el del componente y si no coincide, devolveremos true
      return nocoincide && history && history.length && self.getStrValueHistory(history[0].valor) != self.getStrValueHistory(self.currentResultado || '');
    },
    getStrValueHistory(valor) {
      const self = this;
      let val = valor;
      
      return val;
    },
    getDateHistory(valor) {
      const self = this;
      let val = valor;
      if (val) {
        // si es un string con formato DD/MM/YYYY HH:mm lo convertimos a un objeto Date
        if (typeof val == "string" && (/^\d{2}\/\d{2}\/\d{4}[\s]+\d{2}:\d{2}(:\d{2})?$/i.test(val) )) {
          var dateParts = val.split(" ");
          var datePart = dateParts[0].split("/");
          var timePart = dateParts[1].split(":");
          // month is 0-based, that's why we need dataParts[1] - 1
          while (datePart.length < 3) {
            datePart.unshift(1);
          }
          val = new Date(datePart[2], datePart[1] - 1, + datePart[0], timePart[0], timePart[1]);
        }
        // si es una fecha en formato YYYY-MM-DD o YYYY-MM-DDTHH:mm la convertimos a un objeto Date
        else if (typeof val == "string" && (/^\d{4}-\d{2}-\d{2}[T\s]\d{2}:\d{2}:\d{2}$/i.test(val) || /^\d{4}-\d{2}-\d{2}[T\s]\d{2}:\d{2}$/i.test(val))) {
          val = new Date(val);
        }
        val = DateUtils.dateFormat(val, 'YYYY-MM-DDTHH:mm');
      }
      return val;
    },
    getValueHistory(valor) {
      const self = this;
      return valor;
    },
    setValueHistory: function(val, a, desdeChange = false, extraDataEmit = false, itm) {
      const self = this;
      itm.valor = val;
    },
    updateHistory: function(itm) {
      const self = this;
      // buscamos la entrada del historico en form.historyBulk por el id
      let historyBulk = self.form.historyBulk.find(h => h.id == itm.id);
      if(historyBulk) {
        historyBulk.date = new Date(self.getDateHistory(itm.date));
        historyBulk.username = itm.username;
      }
      let namespaces = (self.name + ".resultado").split(".");
      let context = historyBulk?.nuevo;
      for (var i = 0; i < namespaces.length; i++) {
        if (i == namespaces.length - 1) {
          self.$set(context, namespaces[i], itm.valor);
        } else if (context[namespaces[i]] == null) {
          self.$set(context, namespaces[i], {});
        } else if (typeof context[namespaces[i]] == "undefined") {
          let n = namespaces[i + 1];
          if (0 === n % (!isNaN(parseFloat(n)) && 0 <= ~~n)) {
            //Número entero positivo
            self.$set(context, namespaces[i], []);
          } else {
            self.$set(context, namespaces[i], {});
          }
        }
        context = context[namespaces[i]];
      }
      // console.log("historyBulk", context);
      // ahora guardaremos el historico con su nuevo valor
      self.form.dbAdapter.saveHistory({ itemId: historyBulk.id, data: historyBulk })
        .then(function(res) {
          self.$f7.dialog.alert("El historico se ha actualizado correctamente.");
        })
        .catch(function(error) {
          if(error.status && error.status == 404) {
            console.log("error 404 URL: " + error.url);
          } else {
            app.dialog.alert(error.message);
          }
        });
      self.$refs.popoverHistory.close();
    },
    deleteFieldFromHistory: function(itm) {
      const self = this;
      self.$f7.dialog.confirm(
              "La línea de historico se eliminará y no podrá ser recuperada. ¿Está seguro?",
              "Advertencia",
              () => {
                // el delete va a ser un update en el que hemos eliminado el campo del valor actual
                let historyBulk = self.form.historyBulk.find(h => h.id == itm.id);
                let namespaces = self.name.split(".");
                let context = historyBulk?.nuevo;
                let contextParent = historyBulk?.nuevo;
                for (var i = 0; i < namespaces.length; i++) {
                  if (i == namespaces.length - 1) {
                    self.$set(context, namespaces[i], itm.valor);
                  } else if (context[namespaces[i]] == null) {
                    self.$set(context, namespaces[i], {});
                  } else if (typeof context[namespaces[i]] == "undefined") {
                    let n = namespaces[i + 1];
                    if (0 === n % (!isNaN(parseFloat(n)) && 0 <= ~~n)) {
                      //Número entero positivo
                      self.$set(context, namespaces[i], []);
                    } else {
                      self.$set(context, namespaces[i], {});
                    }
                  }
                  contextParent = context;
                  context = context[namespaces[i]];
                }
                // eliminamos el objeto context del contextParent
                if (contextParent) {
                  delete contextParent[namespaces[namespaces.length - 1]];
                  itm = undefined;
                }
                // ahora guardaremos el historico con su nuevo valor
                self.form.dbAdapter.saveHistory({ itemId: historyBulk.id, data: historyBulk })
                  .catch(function(error) {
                    if(error.status && error.status == 404) {
                      console.log("error 404 URL: " + error.url);
                    } else {
                      app.dialog.alert(error.message);
                    }
                  });
                self.$refs.popoverHistory.close();
              },
              () => {
                // Cancelar
              }
            );
      
    },
    setValue: function(val) {
      const refNode = this.comprobacion;
      const pathNode = this.getValue();
      const hasPathNode = !!(pathNode && typeof pathNode === "object");
      const sameRef = hasPathNode && refNode && refNode === pathNode;
      const currentResult = hasPathNode ? pathNode.resultado : (refNode ? refNode.resultado : undefined);
      if (currentResult === val) {
        return;
      }

      // Fuente de verdad: nodo resuelto por `name` en formData.
      if (hasPathNode) {
        if (Object.prototype.hasOwnProperty.call(pathNode, "resultado")) {
          pathNode.resultado = val;
        } else {
          this.$set(pathNode, "resultado", val);
        }
      } else if (refNode) {
        // Fallback defensivo si no se resolvió por path.
        if (Object.prototype.hasOwnProperty.call(refNode, "resultado")) {
          refNode.resultado = val;
        } else {
          this.$set(refNode, "resultado", val);
        }
      }

      // Mantener sincronía visual si refNode es otra referencia.
      if (refNode && !sameRef) {
        if (Object.prototype.hasOwnProperty.call(refNode, "resultado")) {
          refNode.resultado = val;
        } else {
          this.$set(refNode, "resultado", val);
        }
      }

      this.$emit("changeChild", refNode || pathNode);
    },
    onResultClick: function(valor) {
      var self = this;
      // En edición de formato: volver a pulsar el valor actual lo deselecciona (resultado = null)
      if (self.formato && self.currentResultado === valor) {
        self.setValue(null);
        // Vaciar también valorInicial: si no, al remontar la comprobación el hook mounted vuelve a
        // poner resultado = valorInicial y la deselección no persiste.
        self.$set(self.comprobacion, "valorInicial", null);
        self.defecto = null;
        self.comprobacion.modificadaInspector = true;
        return;
      }
      self.setValue(valor);
      if (valor != "D") {
        self.defecto = null;
      }
      self.comprobacion.modificadaInspector = true;
    },
    openInstruccionesPopup: function() {
      var self = this;
      if (self.formato) {
        self.popupOpenedInstrucciones = true;
        self.$nextTick(function() {
          if (self.$refs.popupInstrucciones) {
            self.$refs.popupInstrucciones.open();
          }
        });
        return;
      }
      var formatoId = self.form && self.form.formData && self.form.formData.formato
          ? self.form.formData.formato.id : null;
      if (formatoId) {
        var dbAdapter = self.offline ? FormatoOffline : Formato;
        dbAdapter.get({ itemId: formatoId }).then(function(formatoLocal) {
          self.instruccionesTexto = Utils.findInstruccionesEnFormato(formatoLocal, self.comprobacion.codigo) || '';
          self.popupOpenedInstrucciones = true;
          self.$nextTick(function() {
            if (self.$refs.popupInstrucciones) {
              self.$refs.popupInstrucciones.open();
            }
          });
        });
      } else {
        self.instruccionesTexto = self.comprobacion?self.comprobacion.instrucciones : '';
        self.popupOpenedInstrucciones = true;
        self.$nextTick(function() {
          if (self.$refs.popupInstrucciones) {
            self.$refs.popupInstrucciones.open();
          }
        });
      }
    },
    setComment: function(val) {
      var self = this;
      // si la comprobación es defectuosa, se añadirá el comentario al defecto seleccionado, pero si no lo es, se añadirá al campo obserbaciones de la comprobación
      if (self.comprobacionDefectuosa()) {
        self.comentarios = val.toUpperCase();
      } else {
        self.$set(self.comprobacion, "observaciones", val.toUpperCase());
      }
    },
    isDisabled: function(condicion) {
      var self = this;
      if(self.offline || !self.form || !self.form.formData || !self.form.formData.formato) {
        return condicion;
      } else {
        let editableEnIntranet = self.form.formData.formato.editarEnIntranet == undefined || self.form.formData.formato.editarEnIntranet;
        return condicion || !self.formato && !editableEnIntranet;
      }
    },
    formateoError: function(comprobacion) {
      let errorHTML = comprobacion.erroresAuditoria.map(e => '<span class="regla-'+e.tipoRegla+'">'+e.nombre + '.- ' + e.error+'</span>').join(' ')
      return errorHTML;
    },
    mostrarError: function(comprobacion) {
      const self = this;
      var app = self.$f7;
      let htmlError = comprobacion.erroresAuditoria.map(e => '<div class="regla regla-'+e.tipoRegla+'" ><span style="color: black;">'+e.nombre + '.- </span>' + e.error+'</div>').join(' ');
      let msg = '<div>' + htmlError + '</div>';
      app.dialog.alert(msg,'Errores del campo');
    }
  },
  mounted: function() {
    var self = this;
    var app = self.$f7;
    if (self.comprobacion.valorInicial && !self.currentResultado) {
      self.setValue(self.comprobacion.valorInicial);
    }
    if (!self.comprobacion.defectosSeleccionados) {
      self.$set(self.comprobacion, "defectosSeleccionados", []);
    }
    // Handler nombrado para poder liberarlo en beforeDestroy y evitar la fuga de listeners
    // (antes era una arrow anónima sin $off, se acumulaban durante toda la sesión).
    self._switchAccordionHandler = (event) => {
      self.$nextTick(() => {
        const accordionEl = self.$el ? self.$el.querySelector('.tpm-accordion') : null;
        if (!accordionEl) {
          return;
        }
        try {
          if (event) {
            self.$f7.accordion.open(accordionEl);
          } else {
            self.$f7.accordion.close(accordionEl);
          }
        } catch (e) {
          console.log(e);
        }
      });
    };
    EventBus.$on("switchAccordion", self._switchAccordionHandler);
    if (self.comprobacion && self.comprobacion.accordionOpened) {
      self.$nextTick(() => {
        const accordionEl = self.$el.querySelector('.tpm-accordion');
        if (!accordionEl) {
          return;
        }
        try {
          self.$f7.accordion.open(accordionEl);
        } catch (e) {
          console.log(e);
        }
      });
    }
  },
  beforeDestroy: function() {
    if (this._switchAccordionHandler) {
      EventBus.$off("switchAccordion", this._switchAccordionHandler);
      this._switchAccordionHandler = null;
    }
  }
};
</script>
